import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout_user_action, select_role_user_action } from "../../../redux/_actions";

function useRoleSelect() {
  const [loading, setloading] = useState(false);
  const [formData, setformData] = useState({});
  const [formInputsError, setFormInputsError] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onRoleSelectClick = async () => {
    setloading(true);
    if (validateForm()) {
      const res = await dispatch(select_role_user_action(formData));
      // navigate or show error
      checkNavigate(res);
    }
    setloading(false);
  };
  const onSignOut = async () => {
    const user_token = await localStorage.getItem('jigsawUser') && JSON.parse(localStorage.getItem('jigsawUser'))
    const refreshToken = user_token?.refresh_token
    await dispatch(logout_user_action({refresh: refreshToken}))
    navigate("/sign-in");
  }

  const checkNavigate = (res) => {
    const role = res && res.data && res.data.role;
   
    if (role === "hiring_manager") {
      navigate("/hiring-manager-onboard");
    } 
    else if (role === "candidate") {
      navigate("/candidate-details");
    } 
    else if (role === "mentor") {
      navigate("/mentor-onboard");
    }    
    else {
      let form_errors = {
        ...formInputsError,
        formSubmitError: "Can not update user role.",
      };
      setFormInputsError(form_errors);
    }
  };
  const onRoleChange = (value) => {
    let data = formData;
    data["role"] = value;
    setformData(data);
  };

  //validate form
  const validateForm = () => {
    let form_errors = {};
    let validate = true;

    //validate role
    if (formData.role === undefined) {
      form_errors = {
        ...formInputsError,
        role: "Please select role.",
      };
      validate = false;
    } else {
      form_errors = {
        role: "",
      };
    }
    setFormInputsError(form_errors);
    return validate;
  };
  return {
    loading,
    formInputsError,

    onRoleSelectClick,
    onRoleChange,
    onSignOut 
  };
}

export default useRoleSelect;
